import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';

import { StoreSchema } from '@/app/providers/store';
import { AppStorage } from '@/shared/constants/app-storage.constant';
import { getCurrentDomain } from '@/shared/lib/helpers/get-domain-from-pathname.helper';

export const baseQuery = (apiUrl: string) =>
	fetchBaseQuery({
		baseUrl: apiUrl,
		prepareHeaders: (headers, { getState }) => {
			headers.set('X-HData-Domain', getCurrentDomain());

			if (apiUrl.includes('/hvar')) {
				headers.set('X-HData-Client', 'hdata-frontend');
			}

			const storageToken = localStorage.getItem(AppStorage.AccessToken);
			const stateToken = (getState() as StoreSchema).user.accessToken;
			const token = storageToken || stateToken;

			if (token) {
				headers.set('Authorization', `Bearer ${token}`);
			}

			return headers;
		},
	});
